import { render, staticRenderFns } from "./ViewCoupon.vue?vue&type=template&id=ed67a9c0&scoped=true&"
import script from "./ViewCoupon.vue?vue&type=script&lang=js&"
export * from "./ViewCoupon.vue?vue&type=script&lang=js&"
import style0 from "./ViewCoupon.vue?vue&type=style&index=0&id=ed67a9c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed67a9c0",
  null
  
)

export default component.exports